var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationMenuOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9119 10.0086L16.0613 4.88734C16.3082 4.64297 16.3082 4.24734 16.0613 4.00359C15.815 3.75922 15.415 3.75922 15.1688 4.00359L10.0238 9.12047L4.83129 3.92734C4.58504 3.68047 4.18504 3.68047 3.93879 3.92734C3.69254 4.17484 3.69254 4.57547 3.93879 4.82234L9.12754 10.0117L3.92004 15.1905C3.67379 15.4348 3.67379 15.8305 3.92004 16.0742C4.16629 16.3186 4.56629 16.3186 4.81254 16.0742L10.0157 10.8998L15.1875 16.0723C15.4338 16.3192 15.8338 16.3192 16.08 16.0723C16.3263 15.8248 16.3263 15.4242 16.08 15.1773L10.9119 10.0086Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMenuOpened);
export default __webpack_public_path__ + "static/media/navigation-menu-opened.4815c79280b2548c02c3089fe2530c39.svg";
export { ForwardRef as ReactComponent };